import type { VideoSyncFunctions } from '../../../AssetCompare/CompareViewContext';
import type { AssetFile } from '../../assetDetail.types';
import { AssetPreview } from '../AssetPreview';
import { PdfViewer } from '../PdfViewer';
import { ImageOverlay, VideoOverlay } from './overlays';

interface Props {
  file: AssetFile;
  annotationsEnabled?: boolean;
  showFullscreen?: boolean;
  syncPlay?: VideoSyncFunctions | null;
}

export function AssetPreviewOverlay({
  file,
  annotationsEnabled = true,
  showFullscreen = true,
  syncPlay,
}: Props) {
  if (!file.downloadUrl) return <AssetPreview file={file} />;
  if (file.assetType === 'image') {
    return (
      <ImageOverlay
        file={file}
        annotationsEnabled={annotationsEnabled}
        showFullscreen={showFullscreen}
      />
    );
  }
  if (file.assetType === 'video') {
    return (
      <VideoOverlay
        file={file}
        annotationsEnabled={annotationsEnabled}
        showFullscreen={showFullscreen}
        syncPlay={syncPlay}
      />
    );
  }
  if (file.assetType === 'document' && file.fileType === 'application/pdf') {
    return (
      <PdfViewer
        file={file}
        annotationsEnabled={annotationsEnabled}
        showFullscreen={showFullscreen}
      />
    );
  }
  return <AssetPreview file={file} />;
}
